import { BaseModel } from '@fry/lib/store';


export class EventType extends BaseModel {

}
